@if (form) {
  <form class="form" [formGroup]="form">
    <section class="form-control">
      <label for="s10code">
        {{ 'BATCH_MAILING.BATCHES_TAB.CREATE_MODAL.S10CODE' | translate }}
      </label>
      <input
        type="text"
        formControlName="s10code"
        name="s10code"
        id="s10code"
      />
      @if (form.get('s10code')?.touched) {
        <app-custom-control-error [setErrors]="form.get('s10code')?.errors" />
      }
    </section>

    <section class="form-control">
      <label for="weight">
        {{ 'BATCH_MAILING.BATCHES_TAB.CREATE_MODAL.WEIGHT' | translate }}
      </label>
      <input
        type="number"
        formControlName="weight"
        name="weight"
        [asterisk]="false"
        (keydown)="deleteSymbols($event, false)"
        id="weight"
      />
      @if (form.get('weight')?.touched) {
        <app-custom-control-error [setErrors]="form.get('weight')?.errors" />
      }
    </section>

    @if (!batchProperties?.isPartialReceipt) {
      <!--    Объявленная ценность-->
      <section class="form-control">
        <label for="declared_value">
          {{
            'BATCH_MAILING.BATCHES_TAB.CREATE_MODAL.DECLARED_VALUE' | translate
          }}
        </label>
        <input
          type="number"
          (keydown)="deleteSymbols($event, true)"
          formControlName="declared_value"
          [asterisk]="false"
          name="declared_value"
          id="declared_value"
        />
        @if (form.get('declared_value')?.touched) {
          <app-custom-control-error
            [setErrors]="form.get('declared_value')?.errors"
          />
        }
      </section>

      <!--    Наложенный платеж-->
      <section class="form-control">
        <label for="cash_on_delivery">
          {{
            'BATCH_MAILING.BATCHES_TAB.CREATE_MODAL.CASH_ON_DELIVERY'
              | translate
          }}
        </label>
        <input
          type="number"
          (keydown)="deleteSymbols($event, true)"
          formControlName="cash_on_delivery"
          name="cash_on_delivery"
          id="cash_on_delivery"
        />
        @if (form.get('cash_on_delivery')?.touched) {
          <app-custom-control-error
            [setErrors]="form.get('cash_on_delivery')?.errors"
          />
        }
      </section>
    }

    <!-- Получатель -->
    <section class="form-control full-width" tabindex="0">
      <app-address-widget-picker
        formControlName="recipient"
        [widgetConfig]="recipientWidgetConfig()"
      />
      @if (form.get('recipient')?.touched) {
        <app-custom-control-error [setErrors]="form.get('recipient')?.errors" />
      }
    </section>

    <!-- Уведомления -->
    <section class="form-control">
      <label for="notification">
        {{ 'BATCH_MAILING.BATCHES_TAB.CREATE_MODAL.NOTIFICATIONS' | translate }}
      </label>
      <select id="notification" formControlName="notification">
        <option value="" disabled hidden></option>
        @for (item of notifications$ | async; track item.value) {
          <option [value]="item?.value">
            {{ item?.label | translate }}
          </option>
        }
      </select>
      @if (form?.get('notification')?.touched) {
        <app-custom-control-error
          [setErrors]="form?.get('notification')?.errors"
        />
      }
    </section>

    @if (form?.get('notification').value === '5') {
      <!-- Способ получения -->
      <section class="form-control">
        <label for="obtaining_method">
          {{
            'BATCH_MAILING.BATCHES_TAB.CREATE_MODAL.OBTAINING_METHOD'
              | translate
          }}
        </label>
        <select
          id="obtaining_method"
          formControlName="obtainingMethod"
          (change)="obtainingMethodChange()"
        >
          @for (method of OBTAINING_METHODS; track method?.value) {
            <option [value]="method?.value">
              {{ method.label | translate }}
            </option>
          }
        </select>
      </section>
    }

    <!-- Штрихкод уведомления -->
    <section class="form-control">
      <label for="notification_s10code">
        {{
          'BATCH_MAILING.BATCHES_TAB.CREATE_MODAL.NOTIFICATION_S10CODE'
            | translate
        }}
      </label>

      <input
        type="text"
        formControlName="notification_s10code"
        name="notification_s10code"
        id="notification_s10code"
      />
      @if (form.get('notification_s10code')?.touched) {
        <app-custom-control-error
          [setErrors]="form.get('notification_s10code')?.errors"
        />
      }
    </section>

    @if (form.get('notification')?.value === '5') {
      @switch (form.get('obtainingMethod')?.value) {
        @case ('1') {
          <!-- E-mail для уведомления -->
          <div class="form-control">
            <label for="email">
              {{
                'BATCH_MAILING.BATCHES_TAB.CREATE_TABLE.WHERE_TO_SEND_NOTIFICATION'
                  | translate
              }}
            </label>

            <input type="text" formControlName="email" id="email" />
            @if (form.get('email')?.touched) {
              <app-custom-control-error
                [setErrors]="form?.get('email')?.errors"
              />
            }
          </div>
        }

        @case ('0') {
          <!-- Телефон для уведомления -->
          <div class="form-control">
            <label for="phone">
              {{
                'BATCH_MAILING.BATCHES_TAB.CREATE_TABLE.WHERE_TO_SEND_NOTIFICATION'
                  | translate
              }}
            </label>

            <input
              type="tel"
              prefix="+375"
              mask=" (00) 0000009"
              formControlName="phone"
              (input)="onInput($event)"
              id="phone"
            />
            @if (form.get('phone')?.touched) {
              <app-custom-control-error
                [setErrors]="form.get('phone')?.errors"
              />
            }
          </div>
        }
      }
    }

    @if (batchProperties?.isEcommerce && batchProperties?.isELS) {
      <!-- Срок хранения -->
      <section class="form-control">
        <label for="shelf_life">
          {{ 'BATCH_MAILING.BATCHES_TAB.CREATE_MODAL.SHELF_LIFE' | translate }}
        </label>

        <input type="number" formControlName="shelf_life" id="shelf_life" />
        @if (form.get('shelf_life')?.touched) {
          <app-custom-control-error
            [setErrors]="form.get('shelf_life')?.errors"
          />
        }
      </section>
    }

    <section class="form-control" tabindex="0">
      <label>
        {{ 'BATCH_MAILING.BATCHES_TAB.CREATE_MODAL.COST' | translate }}
      </label>
      <p class="form-control-select-value">
        {{ form.get('cost')?.value | number: '1.0-2' }}
      </p>
    </section>

    @if (batchProperties?.isPartialReceipt) {
      <!--    Объявленная ценность-->
      <section class="form-control">
        <label for="declared_value2">
          {{
            'BATCH_MAILING.BATCHES_TAB.CREATE_MODAL.DECLARED_VALUE' | translate
          }}
        </label>
        <input
          type="number"
          (keydown)="deleteSymbols($event, true)"
          formControlName="declared_value"
          [asterisk]="false"
          name="declared_value2"
          id="declared_value2"
        />
        @if (form?.get('declared_value')?.touched) {
          <app-custom-control-error
            [setErrors]="form?.get('declared_value')?.errors"
          />
        }
      </section>
    }

    <!-- Особые отметки -->
    <section class="form-control">
      <label for="addons">
        {{ 'BATCH_MAILING.BATCHES_TAB.CREATE_MODAL.SPECIAL_MARKS' | translate }}
      </label>

      <ng-select
        class="ng-select-modal"
        id="addons"
        [items]="addons$ | async"
        [multiple]="true"
        [placeholder]="
          'BATCH_MAILING.BATCHES_TAB.CREATE_MODAL.SPECIAL_MARKS' | translate
        "
        [notFoundText]="'NOT_FOUND' | translate"
        [clearAllText]="'CLEAR_ALL_SELECT' | translate"
        [loadingText]="'loading' | translate"
        [searchable]="false"
        [formControl]="addonsControl"
        appendTo="body"
        bindValue="value"
        labelForId="addons"
      >
        <ng-template ng-option-tmp let-item="item">
          {{ item.label | translate }}
        </ng-template>

        <ng-template ng-label-tmp let-item="item" let-clear="clear">
          <span
            class="ng-value-icon left"
            (click)="clear(item)"
            aria-hidden="true"
          >
            ×
          </span>
          <span class="ng-value-label"> {{ item.label | translate }}</span>
        </ng-template>
      </ng-select>
      @if (
        getControlValidity([
          'bulky',
          'hand_over_personally',
          'description',
          'recipient_payment',
          'careful_fragile',
          'documents_return',
          'coordinate_delivery_interval',
          'open_upon_delivery',
        ])
      ) {
        <app-custom-control-error
          [setErrors]="
            setControlError([
              'time_of_delivery',
              'bulky',
              'hand_over_personally',
              'description',
              'recipient_payment',
              'careful_fragile',
              'documents_return',
              'coordinate_delivery_interval',
              'open_upon_delivery',
            ])
          "
        />
      }
    </section>

    @if (formGroupTimeOfDelivery; as timeGroup) {
      <section class="special-marks full-width">
        <div
          class="special-marks-form-ems"
          [formGroup]="formGroupTimeOfDelivery"
        >
          <h4>{{ 'BATCH_MAILING.BATCHES_TAB.EMS.TITLE' | translate }}</h4>

          <div class="special-marks-form-control form-control">
            <select id="type" formControlName="type">
              @for (item of TYPES_OF_DELIVERY; track item.value) {
                <option [value]="item.value">
                  {{ item.label | translate }}
                </option>
              }
            </select>
          </div>
          <div class="special-marks-form-ems-box">
            @if (
              form.get('time_of_delivery')?.get('type')?.value === 'level2'
            ) {
              <p class="special-marks-form-ems-box-text">
                {{
                  'BATCH_MAILING.BATCHES_TAB.EMS.DESCRIPTION_FOR_SPECIFIED_TIME'
                    | translate
                }}
              </p>
            } @else {
              <p class="special-marks-form-ems-box-text">
                {{ 'BATCH_MAILING.BATCHES_TAB.EMS.DESCRIPTION' | translate }}
              </p>
            }
          </div>

          @if (form.get('time_of_delivery')?.get('type')?.value === 'level4') {
            <div class="row mt-2" [formGroup]="formGroupTimeInterval">
              <div class="col-6 col-sm-6">
                <div class="form-control">
                  <label for="from">
                    {{ 'BATCH_MAILING.BATCHES_TAB.EMS.FROM' | translate }}
                  </label>
                  <ng-select
                    class="ng-select-modal"
                    [items]="emsTimePeriod"
                    id="from"
                    appendTo="body"
                    formControlName="from"
                  />
                  <app-control-errors control="from" />
                  @if (getControlValidity(['time_of_delivery'])) {
                    <app-custom-control-error
                      [setErrors]="setControlError(['time_of_delivery'])"
                    />
                  }

                  @if (timeGroup.errors?.dateLessThan) {
                    <div>
                      <small class="mb-0 error text-danger">
                        {{ 'BATCH_MAILING.BATCHES_TAB.EMS.ERROR' | translate }}
                      </small>
                    </div>
                  }
                </div>
              </div>

              <div class="col-6 col-sm-6">
                <div class="form-control">
                  <label for="to">
                    {{ 'BATCH_MAILING.BATCHES_TAB.EMS.TO' | translate }}
                  </label>
                  <ng-select
                    class="ng-select-modal"
                    [items]="emsTimePeriod"
                    id="to"
                    appendTo="body"
                    formControlName="to"
                  />
                  <app-control-errors control="to" />
                </div>
              </div>
            </div>
          }
        </div>
      </section>
    }
  </form>
}
